import React from 'react';

import {
    FilterLabels,
    FilterPills,
    filterMapper,
} from 'components/common/GlobalFiltersInPage/globalFiltersInPage.utils';

import classes from './ReportPills.module.scss';

// interface Props {}
const MAX_LENGTH = 10;

export const ReportPills = ({ pills }) => {
    return (
        <div className={classes.reportPills}>
            {pills.length > 0 &&
                pills.map((pill, index) => {
                    const pillKey = (FilterLabels[pill.name] || pill.name) + ': ';
                    const pillValues = pill.data || [];
                    const isPillValuesAsArray = pillValues.length > 1;
                    if (pillValues.length === 0) return null;

                    return (
                        <div className={classes.pill} key={pillKey + index}>
                            <span>{pillKey}</span>
                            {pillValues.slice(0, MAX_LENGTH).map((item, index) => {
                                const value = typeof item === 'string' ? FilterPills[filterMapper(item)] || item : item;
                                return (
                                    <span
                                        className={`${classes.pillValue} ${isPillValuesAsArray ? classes.multiple : ''}`}
                                        key={item.toString() + index}
                                    >
                                        {value}
                                    </span>
                                );
                            })}
                            <div className={classes.more}>
                                {pillValues.length > MAX_LENGTH && `& ${pillValues.length - MAX_LENGTH} more...`}
                            </div>
                        </div>
                    );
                })}
        </div>
    );
};
